export default {
  table: {
    marginLeft: -16,
    marginRight: -16,
    '@media screen and (max-width: 600px)': {
      display: 'block',
      marginLeft: 0,
      marginRight: 0,
      '& thead': {
        display: 'none',
      },
      '& tbody': {
        display: 'block',
      },
      '& tr': {
        display: 'block',
        padding: '10px 0',
        borderTop: '1px solid #E5E5E5',
      },
    },
  },
  tableCell: {
    padding: '16px',
    '@media screen and (max-width: 600px)': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '12px',
      borderBottom: 'none',
      padding: '4px 0',
      textAlign: 'right',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      '&[data-label]:before': {
        content: 'attr(data-label)',
        fontWeight: 500,
        textAlign: 'left',
        color: '#615656',
        flex: '0 0 42%',
      },
    },
  },
  button: {
    padding: 0,
  },
};
